import { useAuth } from '@shared/auth';
import {
  type DrawerProps,
  Box,
  Collapse,
  Drawer,
  List,
  ListItemButton,
  styled,
  Text,
} from '@shared/components';

import { useSideBar } from '../../contexts';
import { MENU_DRAWER_WIDTH_LARGE, MENU_DRAWER_WIDTH_SMALL } from '../../utils/constants';
import { NavMenuItem, NestedMenuItem } from '../MenuItem';

import SideBarLogo from './SideBarLogo';
import SideBarStickyMenu from './SidebarStickyMenu';

export const BaseSideBar = styled(Drawer, {
  name: 'SideBar',
  slot: 'Root',
  overridesResolver: (_, styles) => [styles['root']],
  shouldForwardProp: (prop) => prop !== 'minified',
})<DrawerProps & { minified: boolean }>(({ theme, minified }) => ({
  display: 'none',
  [theme.breakpoints.up('md')]: {
    display: 'block',
  },

  '.MuiPaper-root': {
    position: 'relative',
    width: minified ? MENU_DRAWER_WIDTH_SMALL : MENU_DRAWER_WIDTH_LARGE,
    transition: 'all 100ms ease-in-out',
  },
}));

function SideBar() {
  const { isOpen, appMenu } = useSideBar();
  const { userProfile } = useAuth();

  const shouldHideMenu = userProfile?.status !== 'ENABLED';

  const shouldMinify = !isOpen;
  return (
    <BaseSideBar variant='permanent' open minified={shouldMinify}>
      <SideBarLogo minified={shouldMinify} />
      {!shouldHideMenu ? (
        <List>
          {appMenu.map((menu) => (
            <Box key={menu.section ?? menu.items?.[0]?.label}>
              <Collapse in={!shouldMinify}>
                {menu.section ? (
                  <ListItemButton disabled className='section'>
                    <Text>{menu.section}</Text>
                  </ListItemButton>
                ) : null}
              </Collapse>
              {menu.items?.map((item) =>
                item.subMenu ? (
                  <NestedMenuItem key={item.label as string} {...item} minified={shouldMinify} />
                ) : (
                  <NavMenuItem key={item.label as string} {...item} minified={shouldMinify} />
                ),
              )}
            </Box>
          ))}
        </List>
      ) : null}
      <SideBarStickyMenu minified={shouldMinify} />
    </BaseSideBar>
  );
}

export default SideBar;
